import React, {
  useContext,
} from 'react';
import { HeadingBanner } from 'anf-core-react';
import CheckoutPageContext from '../../../context/CheckoutPageContext';
import Tmnt from '../../Tmnt/Tmnt';
import BillingAddressForm from './BillingAddressForm/BillingAddressForm';

export default function BillingAddressContainer() {
  const {
    checkoutPageState,
  } = useContext(CheckoutPageContext);

  const { textFor } = checkoutPageState;

  return (
    <div className="billing-address-container">
      <HeadingBanner variant="boxed">
        <h3>
          <Tmnt tmnt={textFor?.billingAddress} />
        </h3>
      </HeadingBanner>
      <BillingAddressForm />
    </div>
  );
}
